export default "__VITE_ASSET__C7oi7Imc__"